import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  extraData?: any
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError, undefined, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    const permissionIds: Array<number> = props.extraData.permissions.map((p) => p.permission_id)
    response = await axiosPost(apiUrls.roles, formData, catchFunc).then((data) => {
      if (data?.status !== undefined && data.status === 201) {
        permissionIds.forEach((permissionsId) => {
          axiosPost(
            apiUrls.permissionsToRoles,
            {
              permission_id: permissionsId,
              role_id: data.data.id,
            },
            catchFunc,
          )
        })
      }
      return data
    })
  } else {
    response = await axiosPut(apiUrls.roles + '/' + props.id, formData, catchFunc)
  }
  return response
}

export default submitForm
